import React, { PureComponent } from 'react';
import styles from './prompt.module.scss';
import Label from 'components/form/label/label';

class Prompt extends PureComponent {
  render() {
    const { options, onChange, name, value, label } = this.props;
    return (
      <div>
        <div className="row prompt">
          <Label>{label}</Label>
          <div className="col-12">
            {options.map(option => {
              return (
                <input
                  key={option.name}
                  type="button"
                  className={`btn mr-3 mb-2 ${
                    styles.promptButton
                  } ${option.value === value ? styles.selected : styles['not-selected']}`}
                  onClick={() => {
                    // if value already equals....
                    if (option.value === value) {
                      // For already selected buttons, clicking does nothing.
                      return;
                    } else {
                      // Otherwise, apply toggle action.
                      onChange({
                        target: {
                          name,
                          value: option.value
                        }
                      });
                    }
                  }}
                  value={option.name}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default Prompt;
